import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceUserPreferencesEditionNotificationState = createStateReducer(
  initialState,
  {
    [events.editUserPreferencesSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editUserPreferences",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editUserPreferencesFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editUserPreferences",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceUserPreferencesEditionNotificationState };
